import { navigate } from "svelte-routing";

export default {
  logout: () => {
    localStorage.setItem('token', null);
    window.location.reload();
  }
};